import script from "./AllContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllContent.vue?vue&type=script&setup=true&lang=ts"

import "./AllContent.vue?vue&type=style&index=0&id=60abd67c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60abd67c"]])

export default __exports__